import { useNavigate } from "react-router-dom";
import { Tooltip } from "antd";
import classNames from "classnames";
import { InfoCircleOutlined, PlusOutlined } from "@ant-design/icons";
import "./index.less";

const tabList = [
  {
    title: "全部",
    key: "",
  },
  {
    title: "冻结",
    key: "freeze",
    tips: "拟配送订单，因客户的欠款未结清，订单暂时无法通过审核，需客户付清欠款后，订单才能进行配送。",
  },
  {
    title: "待发货",
    key: "waitShipped",
  },
  {
    title: "已发货",
    key: "partShipped",
  },
  {
    title: "已签收",
    key: "completed",
  },
  {
    title: "已取消",
    key: "canceled",
  },
];

const NavTab = ({
  curKey,
  changeTab,
}: {
  curKey: string;
  changeTab: (key: string) => void;
}) => {
  const navigate = useNavigate();

  const gopage = () => {
    navigate("/quickOrder/dytOrder")
  };

  return (
    <div className="tab-wrap flex-b-c">
      <ul>
        {tabList.map(({ title, key, tips }) => (
          <li
            className={classNames({ active: curKey === key })}
            key={title}
            onClick={() => changeTab(key)}
          >
            {title}
            {tips && (
              <Tooltip className="tab-tips" title={tips}>
                <InfoCircleOutlined />
              </Tooltip>
            )}
          </li>
        ))}
      </ul>
      <div className="order-btn" onClick={gopage}>
        <PlusOutlined />
        快速下单
      </div>
    </div>
  );
};

export default NavTab;
